import * as Components from './components';
import * as Pages from './pages';

export const ReactComponents = {
  ...Components,
  ...Pages,
};
